// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const loanTapeTypeSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
  },
  {
    key: 'tapeName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'tapeName',
  },
  {
    key: 'shouldReportDrawsSeparately',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'shouldReportDrawsSeparately',
  },
  {
    key: 'tapeOutputFormat',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'tapeOutputFormat',
    options: ['CSV'],
  },
  {
    key: 'moneyUnit',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'moneyUnit',
    options: ['fullUnit', 'subUnit100'],
  },
  {
    key: 'fieldNameMappings',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'fieldNameMappings',
    nested: [],
  },
  {
    key: 'reportDaysWhenPaidOff',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'reportDaysWhenPaidOff',
    numberFormat: 'integer',
  },
  {
    key: 'compressionType',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'compressionType',
    options: ['gzip', 'noCompression', 'zip'],
  },
  {
    key: 'loanMetaDataFields',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'loanMetaDataFields',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'loanMetaDataFields[0]',
      },
    ],
  },
  {
    key: 'fields',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'fields',
    nested: [
      {
        key: '0',
        type: 'enum',
        required: true,
        component: 'Select',
        fullPath: 'fields[0]',
        options: [
          'reportDate',
          'investorId',
          'investorLegalName',
          'investorOwnershipPercentage',
          'secondInvestorId',
          'secondInvestorLegalName',
          'secondInvestorOwnershipPercentage',
          'loanId',
          'loanStatus',
          'loanExternalId',
          'loanType',
          'loanTypeId',
          'mainBorrowerId',
          'mainBorrowerExternalId',
          'currentCreditLimit',
          'activationDate',
          'lastDueDate',
          'effectiveAPR',
          'interestRate',
          'indexRate',
          'promoRate',
          'interestType',
          'contractualRecurringAmount',
          'amountFinanced',
          'firstDueDateExpectedAmount',
          'firstDueDatePaymentAmountByDueDate',
          'upcomingDueDate',
          'upcomingDueDateExpectedAmount',
          'outstandingBalanceTotalAmount',
          'outstandingBalancePrincipalAmount',
          'outstandingBalanceInterestAmount',
          'outstandingBalanceFeesAmount',
          'creditsAppliedTotalAmount',
          'paymentsMadeTotalAmount',
          'paymentsMadePrincipalAmount',
          'paymentsMadeInterestAmount',
          'paymentsMadeFeesAmount',
          'paymentsMadeOverAmount',
          'paymentsMadeReimbursementsAmount',
          'lastSuccessfulPaymentEffectiveDate',
          'lastSuccessfulPaymentTotalAmount',
          'lastSuccessfulPaymentPrincipalAmount',
          'lastSuccessfulPaymentInterestAmount',
          'lastSuccessfulPaymentFeesAmount',
          'isAutopayOn',
          'recentAutopayAuthorizationDate',
          'isOverdue',
          'overdueNumberDays',
          'overdueBalanceTotalAmount',
          'overdueBalancePrincipalAmount',
          'overdueBalanceInterestAmount',
          'overdueBalanceFeesAmount',
          'nonDueBalanceTotalAmount',
          'nonDueBalancePrincipalAmount',
          'nonDueBalanceInterestAmount',
          'nonDueBalanceFeesAmount',
          'dailyInterestAccruedAmount',
          'dailyInterestDiscountAmount',
          'dailyForgoneInterestCapAmount',
          'dueBalanceTotalAmount',
          'dueBalancePrincipalAmount',
          'dueBalanceInterestAmount',
          'dueBalanceFeesAmount',
          'timesOverdue15Days',
          'timesOverdue30Days',
          'timesOverdue60Days',
          'timesOverdue90Days',
          'timesOverdue120Days',
          'isChargedOff',
          'chargedOffDate',
          'chargedOffPrincipalAmount',
          'chargedOffInterestAmount',
          'chargedOffFeesAmount',
          'chargedOffTotalAmount',
          'chargedOffReason',
          'netInterestAccruedTotalAmount',
          'interestDiscountTotalAmount',
          'forgoneInterestCapAmount',
          'reimbursementAmount',
          'mainBorrowerFirstName',
          'mainBorrowerLastName',
          'mainBorrowerDateOfBirth',
          'mainBorrowerIdentityType',
          'mainBorrowerIdentityValue',
          'mainBorrowerIdentityIssuingCountry',
          'mainBorrowerIdentityIssueDate',
          'mainBorrowerIdentityExpirationDate',
          'mainBorrowerBusinessLegalName',
          'mainBorrowerBusinessType',
          'isInSCRAStatus',
          'activeDutyStartDate',
          'activeDutyEndDate',
          'isInBankruptcy',
          'bankruptcyFiledDate',
          'bankruptcyCourtCaseNumber',
          'bankruptcyLastStatus',
          'bankruptcyDisposition',
          'bankruptcyChapter',
          'currentAddressState',
          'currentAddressPostalCode',
          'currentAddressLine1',
          'currentAddressLine2',
          'currentAddressCity',
          'currentAddressCountry',
          'currentEmail',
          'currentPhone',
          'refundedAmount',
          'merchantId',
          'merchantBusinessName',
          'originalDuration',
          'originalPaymentFrequency',
          'currentPaymentFrequency',
          'currentRecurringAmount',
          'paidOffDate',
          'loanMetaData',
          'isLoanModified',
          'principalAmount',
          'projectedPayoffDate',
          'remainingDuration',
          'dataStatus',
          'overdueOver30DaysBalanceTotalAmount',
          'overdueOver60DaysBalanceTotalAmount',
          'overdueOver90DaysBalanceTotalAmount',
          'overdueOver120DaysBalanceTotalAmount',
          'overdueOver150DaysBalanceTotalAmount',
          'overdueOver180DaysBalanceTotalAmount',
          'nonDueBalanceOriginationFeesAmount',
          'nonDueBalanceDrawFeesAmount',
          'nonDueBalanceLateFeesAmount',
          'nonDueBalanceModificationFeesAmount',
          'dueBalanceOriginationFeesAmount',
          'dueBalanceDrawFeesAmount',
          'dueBalanceLateFeesAmount',
          'dueBalanceModificationFeesAmount',
          'originationFeeAmount',
          'overdueBalanceOriginationFeesAmount',
          'overdueBalanceDrawFeesAmount',
          'overdueBalanceLateFeesAmount',
          'overdueBalanceModificationFeesAmount',
          'outstandingBalanceOriginationFeesAmount',
          'outstandingBalanceDrawFeesAmount',
          'outstandingBalanceLateFeesAmount',
          'outstandingBalanceModificationFeesAmount',
          'nonDueBalanceMembershipFeesAmount',
          'dueBalanceMembershipFeesAmount',
          'overdueBalanceMembershipFeesAmount',
          'outstandingBalanceMembershipFeesAmount',
        ],
      },
    ],
  },
  {
    key: 'actionOnMissingData',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'actionOnMissingData',
    options: ['includeIDsAndEmptyData', 'excludeFromTape'],
  },
  {
    key: 'tapeType',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'tapeType',
    options: ['loans', 'payments'],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(loanTapeTypeSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(loanTapeTypeSchema)
}
